/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, LinkList, LinkListItem, Spinner } from 'design-react-kit';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApiService from "../../../services/api";
import { CategoryClass } from '../../categories/models/category';
import Page404 from '../../pages/page404';
import WidgetNews from './widget_news';
import { WidgetClass } from '../../pages/models/widget';
import WidgetSearch from '../../pages/components/widget_search';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import parse from 'html-react-parser';
import { ActaAuthContext } from "pa_kit/auth";
import { Helmet } from "react-helmet-async";


const PageNewsCategory = () => {

    const auth = useContext(ActaAuthContext);

    const organization = auth.organization;
    const actagov_config = auth.organization.active_licenses?.services?.actagov;

    let { categorySlug } = useParams();

    const [ categoryList, setCategoryList ] = useState();
    const [ category, setCategory ] = useState();    
    const [ isLoading, setIsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const [ mainSection, setMainSection ] = useState({});

    const [ widget, setWidget ] = useState();

    const [ widgetSearch, setWidgetSearch ] = useState();

    const fetchCategory = async() => {
        try {
            const category = await ApiService.getCategory(categorySlug);
            setCategory(new CategoryClass(category));
            setWidget(new WidgetClass({        
                name: "NewsCategoryRow",
                class: "news-category-row",
                category: category.id,
                show_number: 12,
                label: <span></span>   
            }));
            setWidgetSearch(new WidgetClass({
                name: "SearchSection",
                class: "search-allnews-section",
                type: "search",
                label: "Cerca nelle novità",
                search_in: "main_sections",
                search_id: 3
            }));
            setIsLoading(false);
        } catch (error) {
            setPageNotFound(true);            
        }       
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 3); // Novità
        setMainSection(mainSection[0]);
    }

    const fetchCategoryList = async() => {
        const categoryListData = await ApiService.getCategoryList();
        const categoryList = categoryListData.filter(category => category.is_news === true);
        setCategoryList(categoryList);
    }

    useEffect(() => {
        fetchCategory();
        fetchCategoryList();
        fetchMainSections();
    }, []);
       
    if(pageNotFound) return <Page404 />;
    if(isLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>; 
    return <>
        <Helmet>
            <title>{category.name + ' | ' + organization.name}</title>
            <meta name="description" content={category.description.replace(/(<([^>]+)>)/gi, "")} />
        </Helmet>
        <Container fluid className="p-0 news-category-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href='/novita/'>{mainSection.name}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                {category.name}
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title news-category-page-title-page'}>
                <Row>
                    <Col lg="7">
                        <h1>{category.name}</h1>
                        <div className="mt-4">{parse(category.description)}</div>
                        <WidgetSearch widget={widgetSearch} />
                    </Col>
                    <Col lg="5">
                    <Container fluid className={'news-page-menu page-menu-content ms-lg-5 ps-lg-5'}>
                        <p className="menu-name mb-2">Tutte le novità</p>
                        <LinkList>
                            {categoryList && categoryList.map((category) => 
                                <LinkListItem key={"key_menuItem_" + category.name} href={actagov_config?.frontend_url + 'novita/' + category.slug + '/'} className="ps-0 menu-item-link">{category.name}</LinkListItem>
                            )}
                        </LinkList>
                    </Container>
                    </Col>
                </Row>
            </Container>

            <Container className="mt-5">
                <WidgetNews widget={widget} />
            </Container>

            <Container fluid className={'rating-wrapper page-rating news-category-page-rating'}>
                <WidgetPageRating page_title={category.name} />
            </Container> 

            <Container fluid className={'contacts-wrapper news-category-page-contacts'}>
                <WidgetContacts />
            </Container>
        </Container>
    </>;
}

export default PageNewsCategory;